module.exports = __webpack_public_path__ + "img/sc.a2f8e93b.png";